<template>
  <div class="container">
    <el-container class="wrapper" ref="wrapper">
      <el-header height="auto" class="page-header">
        <search-box class="search-box">
          <el-form :inline="true" size="mini">
            <el-form-item label="日期">
              <form-date-range :form="formData" startKey="startTime" :usingTime="false" endKey="endTime" valueFormat="yyyy-MM-dd HH:mm:ss"></form-date-range>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
          </template>
        </search-box>
      </el-header>
      <el-main  ref="main">
        <div style="margin-bottom: 10px;">
          <el-button type="primary" size="small" @click="showExport">批量导入</el-button>
          <el-button type="primary" size="small" @click="downLoadTemplate">下载模板</el-button>
        </div>
        <el-table
          border
          :header-cell-style="{backgroundColor: '#F4F8FB'}"
          :data="tableData"
          :height="tableHeight"
          v-if="tableHeight"
          v-loading="loading"
        >

          <el-table-column label="文件名" prop="fileName" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column label="更新说明" prop="updateInstructions" show-overflow-tooltip></el-table-column> -->
          <el-table-column label="导入人" prop="importUser" show-overflow-tooltip  ></el-table-column>
          <!-- <el-table-column label="状态" prop="status" show-overflow-tooltip width="180px"></el-table-column> -->
          <el-table-column label="导入时间" prop="importDate" show-overflow-tooltip ></el-table-column>
          <el-table-column label="操作" width="100px">
            <template slot-scope="scope">
                <el-button type="text" @click="downLoadRequest(scope.row.urlAddress, scope.row.fileName)">下载</el-button>
              </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 15px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
    <el-dialog :title="titleName" width="60%;" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="handleDialogClose">
      <div slot="footer" class="dialog-footer">
        <el-form :model="requestParam" :rules="rules" ref="requestParam" label-width="100px" size="small">
          <el-row>
            <el-col :span="24" align="left">
              <el-form-item label="附件" prop="goodsCode">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  accept=".xls,.xlsx,.xls.ttt,.xlsx.ttt"
                  :limit="1"
                  action=""
                  :http-request="httpRequest"
                  :on-remove="handleRemove"
                  :headers="headers"
                  :file-list="fileList"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                >
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <el-button style="margin-left: 10px;"
                             v-loading.fullscreen.lock="fjLoading"
                             element-loading-text="数据导入中"
                             element-loading-spinner="el-icon-loading"
                             element-loading-background="rgba(0, 0, 0, 0.8)"
                             size="small" type="success" @click="checkFormValid">上传
                  </el-button>
                  <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且只能上传一个</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button @click="cancel" size="medium">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import searchBar from './search';
  import {getToken} from '@/utils/auth'
  import pagePathMixin from '@/utils/page-path-mixin'
  export default {
    components:{
      searchBar,
    },
    mixins: [pagePathMixin],
    data(){
      return {
        requesting:false,
        headers: {
          'Authorization': getToken()
        },
        fileList:[],
        dialogFormVisible:false,
        options:[],
        titleName:'',
        requestParam:{},
        tableData:[],
        formData:{},
        formDataImport:{},
        rules: {},
        fjLoading: false,
        loading:false,
        tableHeight:0,
        paginationOpt: {
          pageSizes: [30, 60, 90],
          pageSize: 30,
          pageNum: 1,
          total: 0
        },
      }
    },
    mounted(){
      this.tableHeight = this.$refs['wrapper'].$el.offsetHeight - 165;
      this.init()
    },
    methods:{
      cancel() {
        this.dialogFormVisible = false;
      },
      handleDialogClose() {
        this.fileList = [];
      },
      handleRemove(file, fileList) {
        this.fileList = [];
        console.log(file, fileList);
      },
      httpRequest(file) {

      },
      handleSuccess(res, file) {
        if (res.code === 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
        this.cancel();
        this.handleSearch();
      },
      // 验证
      beforeUpload(file) {
        // .xls,.xlsx,.xls.ttt,.xlsx.ttt
        let pattern = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (['xls', 'xlsx', 'xls.ttt', 'xlsx.ttt'].indexOf(pattern.toLowerCase()) === -1) {
          this.$message.error('请上传后缀名为.xls,.xlsx的附件！');
          return false;
        }
        this.fileList = [];
        this.fileList.push(file);
      },
      checkFormValid(file) {
       this.$refs['requestParam'].validate(valid=>{
          if(valid) {
            this.submitUpload(file);
          }else{
            this.$message.error('参数校验失败！')
          }
        })
      },
      submitUpload(file) {
        if (!this.fileList || this.fileList.length === 0) {
          this.$message.error('请先上传Excel附件');
          return;
        }
        this.fjLoading = true;
        this.formDataImport = new FormData()
        this.$refs.upload.submit()
        this.formDataImport.append('file', this.fileList[0])
        this.$q.dataImport.shortagePackImport({
          data: this.formDataImport,
        }).then((res) => {
          if (res.success) {
            this.$message.success('数据导入中，请稍后');
          } else {
            this.$message.error(res.message);
          }
          this.fjLoading = false;
          this.cancel();
          this.handleSearch();
        }).catch(err=>{
          this.fjLoading = false
        })
      },
      showExport() {
        this.fileList = [];
        this.dialogFormVisible = true;
        // let filename = this.$route.query.fileName;
        // filename = filename.substring(0, filename.lastIndexOf('.'))
        this.titleName = '出货时间批量维护';
      },
      downLoad(path, name) {
        let url = path;
        let fileName = name;
        var xhr = new XMLHttpRequest();
        xhr.open("GET",url, true);
        xhr.responseType = "blob";
        xhr.onload = function() {
          if (xhr.status === 200) {
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(xhr.response, fileName);
            } else {
              var link = document.createElement("a");
              var body = document.querySelector("body");

              link.href = window.URL.createObjectURL(xhr.response);
              link.download = fileName;

              // fix Firefox
              link.style.display = "none";
              body.appendChild(link);

              link.click();
              body.removeChild(link);
              window.URL.revokeObjectURL(link.href);
            }
          }
        };
        xhr.send();
      },
      blobDownload(res,fileName) {
        let objectUrl = window.URL.createObjectURL(res);
        let a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        a.click()
        a.remove();
      },
      downLoadRequest(filePath, fileName) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(_=>{
          this.downLoad(filePath, fileName)
          loading.close();
        },300)
        // this.$q.newProduct.downLoadExcuseExcel({
        //   data: {
        //     fileId: fileId,
        //     spuId: spuId
        //   },
        //   options: {
        //     responseType: 'blob'
        //   }
        // })
        //   .then(res=>{
        //     this.blobDownload(res, fileName)
        //   })
      },
      handleSearch(){
        this.paginationOpt.pageNum = 1
        this.init()
      },
      init() {
        this.loading = true;
        let data = {
          filterData: {
            ...this.formData,
            fileType: 3
          },
          pageNum: this.paginationOpt.pageNum,
          pageSize: this.paginationOpt.pageSize
        };
        this.$q.dataImport.packImportRecord({data})
          .then(res=>{
            if(res.code == 200) {
              this.tableData = res.data.records;
              this.paginationOpt.total = res.data.total;
            }else{
              this.tableData = [];
            }
          })
          .finally(_=>{
            this.loading = false;
          })
      },
      // 分页器 pagesize
      handleSizeChange(val) {
        this.paginationOpt.pageSize = val;
        this.paginationOpt.pageNum = 1;
        this.init();
      },
      // 分页器 pageNum
      handleCurrentChange(val) {
        this.paginationOpt.pageNum = val;
        this.init();
      },
      /**
       * 下载模板
       */
      // 获取导入模板
      downLoadTemplate() {
         const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$q.dataImport.shortagePackDow({options: {responseType: 'blob'}}).then((res)=>{
          loading.close();
          let fileName = '包件出货时间导入模板';
          this.blobDownload( res, `${fileName}.XLSX`);
        })
      },
    }
  }
</script>
<style lang="stylus" scoped>
.container
  margin 5px
  width auto
  height calc(100% - 10px)
  box-sizing border-box
  border-radius 5px

.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important

>>> .el-header
  background #ffffff
  padding: 0
  margin-bottom 5px !important
  position relative
  border-radius 5px
>>> .el-main
  padding 10px
  background #ffffff
  border-radius 5px

>>> .el-tabs__header
  margin-bottom 0

>>> .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item
  margin-bottom: 0 !important
</style>


